import Swal from "sweetalert2"
import { PopUpContainer, PopUpContent, PopUpHeader, PopUpParagraph, PopUpTitle } from './style'
import 'components/popup/style.css'
import React from "react"
import { renderToString } from "react-dom/server"

export interface StartupAlreadyExistsModalProps {
    title: string
    message: string | JSX.Element
    onConfirm?: () => void
    onCancel?: () => void
}

export const StartupAlreadyExistsModal = ({ title, message, onConfirm, onCancel }: StartupAlreadyExistsModalProps): void => {
    const content = (
      <PopUpContainer>
        <PopUpHeader>
          <PopUpTitle>{title}</PopUpTitle>
        </PopUpHeader>
        <PopUpContent>
          <div style={{ marginBottom: '32px' }}>
            {typeof message === 'string' ? <PopUpParagraph>{message}</PopUpParagraph> : message}
          </div>
        </PopUpContent>
      </PopUpContainer>
    )

    Swal.fire({
        showCloseButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Confirmar',
        confirmButtonColor: '#0066B3',
        allowOutsideClick: true,
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        customClass: {
            popup: 'startup-already-exists-modal',
            closeButton: 'startup-already-exists-modal-close',
            container: 'startup-already-exists-modal-container',
            actions: 'startup-already-exists-modal-actions',
            confirmButton: 'startup-already-exists-modal-confirm',
            cancelButton: 'startup-already-exists-modal-cancel'
        },
        html: renderToString(content),
        width: '800px',
        padding: 0,
        backdrop: 'rgba(0,0,0,0.4)'
    }).then((result) => {
      if (result?.isConfirmed) {
        if (onConfirm !== undefined) onConfirm()
      } else {
        if (onCancel !== undefined) onCancel()
      }
    })
}